import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAdmin } from '../../../../../../reducers/onboarding';
import mixpanel from 'mixpanel-browser';

class PensionContributionStep extends React.Component {
    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'PensionContributionStep' } });

        const { admin, client, getAdmin } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin } = this.props;
        if (!admin) {
            return null;
        }

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'pensionContribution.intro1'}
                            defaultMessage={
                                'To help people save more for their retirement, all employers are now required by law to provide a workplace pension scheme for certain staff and pay money into it'
                            }
                            tagName={'h5'}
                        />
                        <FormattedMessage
                            id={'pensionContribution.intro2'}
                            defaultMessage={
                                'We therefore will enrol you in the near future into our pension scheme as long you met all of the following criteria:'
                            }
                            tagName={'p'}
                        />
                        <ul>
                            <FormattedMessage
                                id={'pensionContribution.intro2.item1'}
                                defaultMessage={'You earn over £192 per week (or £833 per month)'}
                                tagName={'li'}
                            />
                            <FormattedMessage id={'pensionContribution.intro2.item2'} defaultMessage={'You are aged 22 or over and'} tagName={'li'} />
                            <FormattedMessage id={'pensionContribution.intro2.item3'} defaultMessage={'You are under state pension age.'} tagName={'li'} />
                        </ul>
                        <FormattedMessage
                            id={'pensionContribution.intro3'}
                            defaultMessage={
                                'You can opt out of the pension scheme if you want to, but if you stay in you will have your own personal pension when you retire. Your pension will belong to you, even if you leave us in the future. Please just get in touch if you have any questions.'
                            }
                            tagName={'p'}
                        />
                        <FormattedMessage
                            id={'pensionContribution.intro4'}
                            defaultMessage={
                                'Both you and we will pay contributions into it every pay period, and the government will also contribute through tax relief.'
                            }
                            tagName={'p'}
                        />
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.continue} /> }} />
                </form>
            </div>
        );
    }
}

PensionContributionStep = reduxForm(formSettings)(PensionContributionStep);

const mapStateToProps = state => {
    return {
        admin: state.onboarding.admin,
        client: state.onboarding.client
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PensionContributionStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/pensionContribution.jsx